import "../../../index49.css";
import { jsxs as d, jsx as i, Fragment as y } from "react/jsx-runtime";
import b from "react";
import { RadioButtonLineIcon as h, CheckboxBlankCircleLineIcon as C } from "@ifrc-go/icons";
import { _ as N } from "../../../cs-piwRuCFZ.js";
import "../../../type-BFTbooL7.js";
import k from "../../../hooks/useBasicLayout/index.js";
const O = "_radio_1uudv_1", x = "_icon_1uudv_5", g = "_content_1uudv_10", B = "_description_1uudv_16", L = "_input_1uudv_21", R = "_active_1uudv_37", j = "_disabled_1uudv_43", I = "_read-only_1uudv_55", n = {
  radio: O,
  icon: x,
  content: g,
  description: B,
  input: L,
  active: R,
  disabled: j,
  readOnly: I
};
function E(r) {
  const {
    name: o,
    label: l,
    description: a,
    className: u,
    value: e,
    inputName: c,
    onClick: t,
    disabled: s,
    readOnly: _,
    actions: m
  } = r, p = b.useCallback(() => {
    t && t(o);
  }, [o, t]), {
    content: v,
    containerClassName: f
  } = k({
    icons: e ? /* @__PURE__ */ i(h, { className: n.icon }) : /* @__PURE__ */ i(C, { className: n.icon }),
    actions: m,
    childrenContainerClassName: n.content,
    children: /* @__PURE__ */ d(y, { children: [
      l,
      a && /* @__PURE__ */ i("div", { className: n.description, children: a })
    ] }),
    spacing: "compact",
    withoutWrap: !0
  });
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ d(
      "label",
      {
        className: N(
          n.radio,
          e && n.active,
          s && n.disabled,
          _ && n.readOnly,
          f,
          u
        ),
        children: [
          /* @__PURE__ */ i(
            "input",
            {
              className: n.input,
              type: "radio",
              name: typeof c == "string" ? c : void 0,
              checked: e,
              onClick: p,
              disabled: s,
              readOnly: !0
            }
          ),
          v
        ]
      }
    )
  );
}
export {
  E as default
};
